// src/components/ScrollProgress.jsx
import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function ScrollProgress() {
  const barRef = useRef(null)

  useEffect(() => {
    const bar = barRef.current
    if (!bar) return

    gsap.set(bar, { scaleX: 0, transformOrigin: "0 50%" })

    const tween = gsap.to(bar, {
      scaleX: 1,
      ease: "none",
      scrollTrigger: {
        start: 0,
        end: "max",
        scrub: true,
      },
    })

    return () => tween.kill()
  }, [])

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: 4,
        width: "100%",
        background: "transparent",
        zIndex: 1000,
      }}
      aria-hidden
    >
      <div
        ref={barRef}
        style={{
          height: "100%",
          width: "100%",
          background: "linear-gradient(90deg,#22d3ee,#a78bfa)",
        }}
      />
    </div>
  )
}
